<template>
  <div class="gradelist">
    <van-nav-bar class="isccc mb-16" title="考试结果" left-arrow @click-left="onBack" />
    <div class="container pl-16 pr-16">
      <template v-if="list && list.length">
        <div @click="onGrade(item)" v-for="(item, index) in list" :key="index" class="score-item">
          <img class="score-item-img" :src="item.collegeLogoUrl">
          <div class="score-item-content">
            <div class="sic-title">{{item.collegeName}}</div>
            <div class="sic-site">{{item.specialtyName || ''}}{{item.branchName || ''}}{{item.resultType == 1 && item.hasPass == 1 ? (item.resultTitle ? item.resultTitle : '合格证') : '考试结果'}}</div>
          </div>
          <van-icon class="score-item-icon" size='20' name="arrow" />
        </div>
      </template>
      <div v-else class="isnone">
        <img class="isnoneimg" src="../../static/img_wsj.png">
        <div class="isnonetext">没有发现数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant'
import * as _localStorage from '@/utils/storage'
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  data() {
    return {
      info: '',
      list: [],
    }
  },
  async created() {
    this.list = _localStorage.getStorageSync('resultList')
  },
  methods: {
    onBack() {
      this.$router.back()
    },
    onGrade(val) {
      _localStorage.setStorageSync('grade', val)
      const collegeId =  _localStorage.getStorageSync('collegeId')
      this.$router.push('/result?collegeId=' + collegeId)
    }
  },
}
</script>

<style lang="less" scoped>
.gradelist {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.container {
  width: 100%;
  // flex: 1;
  max-height: calc(100vh - 46px);
  // display: flex;
  // flex-direction: column;
  // justify-content: flex-start;
  // align-items: center;
  overflow: auto;
}
.isccc /deep/ .van-icon {
  color: #323233;
}

.score-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 8px;
}

.score-item-img {
  width: 44px;
  height: 44px;
  border-radius: 8px;
}

.score-item-content {
  flex: 1;
  padding: 0 12px;
  word-break: break-all;
}

.sic-title {
  font-size: 13px;
  font-family: PingFang SC;
  color: #58595d;
}

.sic-site {
  margin-top: 5px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #212b36;
}

.score-item-icon {
  width: 18px;
  height: 18px;
  color: #a2a6b8;
}

.isnone {
  padding-top: 125px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.isnoneimg {
  width: 245px;
  height: 170px;
  /* margin-bottom: 30px/2; */
}

.isnonetext {
  font-size: 16px;
  font-family: PingFang SC;
  color: #a2a6b8;
}
</style>